export default __webpack_public_path__ + "static/media/8-EarlyEveningWalk.c4d55522.jpeg";